/**
 * User-provided marketing CTA photos (site owner licensed).
 * Served from frontend/public/marketing/cta/.
 * Split-screen VS of two MLB pitchers; NFL/NBA action lives on the hero carousel.
 */
export const marketingCtaPhotos = [
  {
    sport: "mlb",
    src: "/marketing/cta/randy-johnson-yankees.webp",
    alt: "Randy Johnson pitching for the New York Yankees",
    objectPosition: "55% 30%",
    label: "Johnson",
  },
  {
    sport: "mlb",
    src: "/marketing/cta/roger-clemens-red-sox.webp",
    alt: "Roger Clemens pitching for the Boston Red Sox",
    objectPosition: "45% 32%",
    label: "Clemens",
  },
];
